import classnames from 'classnames';
import { useMemo } from 'react';

import { ConnectivityState } from 'API';

import './styles/VehicleIdentifier.scss';

interface Props {
    name?: string | null;
    licensePlate?: string | null;
    vin: string;
    connectivityState?: ConnectivityState | null;
}

const VehicleIdentifier = ({ name, licensePlate, vin, connectivityState }: Props) => {
    const connectivity = useMemo(() => {
        if (connectivityState === ConnectivityState.ONLINE) {
            return {
                icon: 'rioglyph rioglyph-wifi',
                className: 'VehicleIdentifier__icon--online',
            };
        }

        return {
            icon: 'rioglyph rioglyph-wifi-off',
            className: 'VehicleIdentifier__icon--offline',
        };
    }, [connectivityState]);

    return (
        <div
            data-testid='vehicle-identifier'
            className={classnames('VehicleIdentifier__content', {
                'VehicleIdentifier__content--single': !name && !licensePlate,
            })}
        >
            <p className='VehicleIdentifier__line VehicleIdentifier__text' data-testid='vehicle-identifier-main'>
                {name ?? licensePlate ?? vin}
                <span
                    data-testid='vehicle-connectivity-icon'
                    className={`VehicleIdentifier__icon ${connectivity.icon} ${connectivity.className}`}
                />
            </p>
            {name || licensePlate ? (
                <p className='VehicleIdentifier__line VehicleIdentifier__text--small VehicleIdentifier__text--gray'>
                    {name || licensePlate ? <span data-testid='vehicle-identifier-vin'>{vin}</span> : null}
                    {name && vin && licensePlate ? (
                        <span className='VehicleIdentifier__separator' data-testid='vehicle-identifier-separator' />
                    ) : null}
                    {name && licensePlate ? (
                        <span data-testid='vehicle-identifier-alternative'>{licensePlate}</span>
                    ) : null}
                </p>
            ) : null}
        </div>
    );
};

export default VehicleIdentifier;
